import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { doLoginSuccess } from '../../actions/Auth'

const initialState = {
  redirect: false
}

class Validate extends Component {
  constructor () {
    super()
    this.state = initialState
  }
  componentDidUpdate (prevProps, prevState) {
    if (prevProps.auth.valid && !this.props.auth.valid) {
      this.setState({ redirect: true })
    }
  }
  componentWillMount () {
    const bearer = window.localStorage.getItem('it.clubhub.bearer')
    if (bearer !== undefined && bearer !== null) {
      this.props.doLoginSuccess({
        bearer,
        email: window.localStorage.getItem('it.clubhub.email'),
        time: window.localStorage.getItem('it.clubhub.time'),
        grant: window.localStorage.getItem('it.clubhub.grant'),
        club: window.localStorage.getItem('it.clubhub.club'),
        userid: window.localStorage.getItem('it.clubhub.userid'),
        fiscalyear: window.localStorage.getItem('it.clubhub.fiscalyear')
      })
    } else {
      if (window.location.pathname !== '/accedi') {
        this.setState({ redirect: true })
      }
    }
  }
  render () {
    return (
      <div>
        {
          this.state.redirect && (
            <Redirect to='/accedi' />
          )
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { doLoginSuccess })(Validate)



// WEBPACK FOOTER //
// ./src/components/Bone/Validate.js